import { createFileRoute, Outlet } from '@tanstack/react-router'

import { useTranslate } from '@orus.eu/pharaoh'

import { GenericProblemMessage } from '../../../components/organisms/generic-problem-message.tsx'
import { InviteToLoginPage } from '../../../components/templates/invite-to-login/invite-to-login-page.tsx'
import { useBackofficeUser } from '../../../lib/use-permissions.ts'

export const Route = createFileRoute('/bo/tools')({
  component: function Component() {
    const translate = useTranslate()
    const backofficeUser = useBackofficeUser()

    if (!backofficeUser) {
      return <InviteToLoginPage />
    }

    if (backofficeUser.type !== 'platform') {
      return (
        <GenericProblemMessage
          title={translate('backoffice_platform_tools_access_denied_title')}
          principalMessage={translate('backoffice_platform_tools_access_denied_message')}
          firstSubText={translate('backoffice_platform_tools_access_denied_sub_text')}
          onButtonClick={() => window.history.back()}
          buttonText={translate('backoffice_platform_tools_access_denied_back_button')}
        />
      )
    }

    return <Outlet />
  },
})
